import React from 'react'
import { Modal, useModal } from 'layouts/modal'
import { Translate } from 'utils/localize'
import SectionById from 'queries/section-by-id'
import ReactMarkdown from 'utils/markdown'
import SectionType from 'models/types/ts/sectionType'
import { useSelector } from 'react-redux'
import { GlobalState } from 'types'
import style from './TermsAndConditions.module.scss'

const TermsAndConditions = (): JSX.Element => {
    const { isOpen, toggleModal } = useModal()
    const language = useSelector((state: GlobalState) => state.language)

    return (
        <div className={style.tos}>
            <button
                type="button"
                className={style.highlight}
                onClick={toggleModal}
            >
                <Translate id="recruit.termsAndConditions">
                    Terms and Conditions
                </Translate>
            </button>
            <Modal isOpen={isOpen} hide={toggleModal}>
                <SectionById
                    identifier="terms-and-conditions-used-for-recruitment-page"
                    locale={language}
                >
                    {(section: SectionType) => {
                        if (section) {
                            return (
                                <div className={style.content}>
                                    <ReactMarkdown source={section.body} />
                                </div>
                            )
                        }
                    }}
                </SectionById>
            </Modal>
        </div>
    )
}

export default TermsAndConditions
